export function hasImpactFields(values) {
  return Object.prototype.hasOwnProperty.call(values, 'impact_clickid');
}
